import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Divider, ListItemIcon, Menu, MenuItem, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LogoutIcon from "@mui/icons-material/Logout";

import { NavContext } from "../../App";
import { Persistor } from "../..";
import New from "../../Pages/SAV/NewSAVTicket/NewSAVTicket";
import Logout from "./Logout";
import NotificationList from "../Notification/NotificationList";
import SpecialNotificationList from "../Notification/SpecialNotificationList";
import { logoutUser } from "../../ReduxTLK/features/User/LoginSlice";
import { addTab, setLastActiveTab } from "../../ReduxTLK/features/Tabs/TabsSlice";

const AJOUT_TICKET_TAB_ID = 2;

/* Style centralisé — cohérent avec le design system du module Filter */
const addBtnSx = {
  height: 36,
  px: 1.75,
  borderRadius: "8px",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.8125rem",
  fontWeight: 600,
  textTransform: "none",
  whiteSpace: "nowrap",
  color: "#fff",
  backgroundColor: "#2A66C6",
  boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
  transition: "all 0.15s ease",
  "&:hover": {
    backgroundColor: "#1F4FA0",
    boxShadow: "0 4px 12px rgba(42, 102, 198, 0.25)",
    transform: "translateY(-1px)",
  },
};

const menuPaperSx = {
  mt: 1,
  minWidth: 190,
  borderRadius: "10px",
  border: "1px solid #e5e7eb",
  boxShadow: "0 8px 24px rgba(16, 24, 40, 0.1)",
};

export default function NavBarButtons() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const context = useContext(NavContext);

  const isAutoLogin = localStorage.getItem("iframeAutoLogin") === "true";

  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationListOpen, setNotificationListOpen] = useState(false);

  /* ---------- Onglet "Ajout Ticket" ---------- */
  const openAjoutTicket = () => {
    const activate = () => {
      context.setActiveTab(AJOUT_TICKET_TAB_ID);
      dispatch(setLastActiveTab(AJOUT_TICKET_TAB_ID));
    };

    if (context.tabs.some((tab) => tab.id === AJOUT_TICKET_TAB_ID)) {
      activate();
      return;
    }

    dispatch(
      addTab({
        module: "SAV",
        action: "Ajout Ticket",
        identifier: AJOUT_TICKET_TAB_ID,
        id: AJOUT_TICKET_TAB_ID,
        label: "Ajout Ticket",
      })
    );
    context.setTabs([
      ...context.tabs,
      {
        id: AJOUT_TICKET_TAB_ID,
        identifier: AJOUT_TICKET_TAB_ID,
        label: "Ajout Ticket",
        component: <New />,
        closeable: true,
        icon: <AddIcon />,
      },
    ]);
    Persistor.persist();
    activate();
  };

  /* ---------- Menu utilisateur ---------- */
  const openNotificationList = (event) => {
    setAnchorEl(event.currentTarget);
    setNotificationListOpen(true);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logoutUser());
    context?.signalRService?.connection?.stop();
    navigate("/");
  };

  return (
    <>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{ px: 2, py: 1, height: "100%" }}
      >
        <Button startIcon={<AddIcon sx={{ fontSize: 18 }} />} onClick={openAjoutTicket} disableElevation sx={addBtnSx}>
          Ajout Ticket
        </Button>

        <Divider orientation="vertical" flexItem sx={{ my: 1, borderColor: "#e5e7eb" }} />

        <SpecialNotificationList
          open={notificationListOpen}
          setNotificationListOpen={setNotificationListOpen}
          openNotificationList={openNotificationList}
        />
        <NotificationList
          open={notificationListOpen}
          setNotificationListOpen={setNotificationListOpen}
          openNotificationList={openNotificationList}
        />

        {!isAutoLogin && <Logout />}
      </Stack>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: menuPaperSx } }}
      >
        <MenuItem
          onClick={handleLogout}
          sx={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#B42318",
            px: 2,
            py: 1.25,
            gap: 0.5,
            "&:hover": { backgroundColor: "#FEF3F2" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 28, color: "#B42318" }}>
            <LogoutIcon sx={{ fontSize: 18 }} />
          </ListItemIcon>
          Se déconnecter
        </MenuItem>
      </Menu>
    </>
  );
}